import React, { useState, useEffect } from 'react';
import {
    empty
} from '__globals/global-functions';
import {
    getJsonContent, getJsonResultCopy,
    setContent
} from "__globals/copy-functions";

import * as GC from '__globals/GLOBAL-CONSTANTS.js';

export const ThankYouActionButtons = props => {

    // LOCAL VARIABLES
    const [currentThankYouScreen, setCurrentThankYouScreen] = useState(undefined);

    const [showActionOne, setShowActionOne] = useState(false);
    const [showActionTwo, setShowActionTwo] = useState(false);
    const [showActionThree, setShowActionThree] = useState(false);

    const [actionOne, setActionOne] = useState('');
    const [valueOne, setValueOne] = useState('');

    const [actionTwo, setActionTwo] = useState('');
    const [valueTwo, setValueTwo] = useState('');

    const [actionThree, setActionThree] = useState('');
    const [valueThree, setValueThree] = useState('');

    /** SET THE CURRENT RESULT SCREEN **/
    useEffect(() => {
        if ( !empty(props.promotion) && !empty(props.gameClaim) ) {
            if ( !empty(props.gameClaim?.parameters?.thankYouScreen) ) {
                setCurrentThankYouScreen( props.gameClaim.parameters.thankYouScreen );
            }
        }
    }, [props.promotion], [props.gameClaim] );

    /** GET CONTENT ACTIONS AND VALUE FOR THE BUTTONS **/
    useEffect(() => {
        if (!empty(currentThankYouScreen)) {
            setShowActionOne( currentThankYouScreen["actionOne"].show );
            setShowActionTwo( currentThankYouScreen["actionTwo"].show );
            setShowActionThree( currentThankYouScreen["actionThree"].show );
            setActionOne( currentThankYouScreen["actionOne"].action);
            setValueOne( currentThankYouScreen["actionOne"].value);
            setActionTwo( currentThankYouScreen["actionTwo"].action);
            setValueTwo( currentThankYouScreen["actionTwo"].value);
            setActionThree( currentThankYouScreen["actionThree"].action);
            setValueThree( currentThankYouScreen["actionThree"].value);
        }
    }, [currentThankYouScreen]);
    useEffect(() => {
        if ( showActionOne && !empty(props.promotion) ) {
            let thankYouButton1 = getJsonContent(props.promotion, props.jsonKey, "button1", "<h2>DEFAULT BTN 1</h2>", props.entry );
            setContent("thankyou_button_1", thankYouButton1);
        }
    }, [showActionOne]);
    useEffect(() => {
        if ( showActionTwo && !empty(props.promotion) ) {
            let thankYouButton2 = getJsonContent(props.promotion, props.jsonKey, "button2", "<h2>DEFAULT BTN 2</h2>", props.entry );
            setContent("thankyou_button_2", thankYouButton2);
        }
    }, [showActionTwo]);
    useEffect(() => {
        if ( showActionThree && !empty(props.promotion) ) {
            let thankYouButton3 = getJsonContent(props.promotion, props.jsonKey, "button3", "<h2>DEFAULT BTN 3</h2>", props.entry );
            setContent("thankyou_button_3", thankYouButton3);
        }
    }, [showActionThree]);
    /** END GET CONTENT ACTIONS AND VALUE FOR THE BUTTONS **/


    const handleActionButton1 = () => {
        props.doAction( actionOne , valueOne );
    }

    const handleActionButton2 = () => {
        props.doAction( actionTwo , valueTwo );
    }

    const handleActionButton3 = () => {
        props.doAction( actionThree , valueThree );
    }


    return (
        <React.Fragment>
            <div id="thankyou_buttons_wrapper">
                {showActionOne && <div id="thankyou_button_1" onClick={handleActionButton1}>Action One</div>}
                {showActionTwo && <div id="thankyou_button_2" onClick={handleActionButton2}>Action Two</div>}
                {showActionThree && <div id="thankyou_button_3" onClick={handleActionButton3}>Action Three</div>}
            </div>
        </React.Fragment>
    );

}